import { Component } from "react"
import { MenuItem } from "@mui/material"
import PropTypes from "prop-types"

class Result extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
  }

  onClick = () => {
    const { item, onClick } = this.props
    onClick(item)
  }

  render() {
    const { item: { name, disabled, info } } = this.props

    return <MenuItem classes={{ root: "result-item" }} component="div" disabled={disabled} onClick={this.onClick} title={name}>
      <div className="result-label">{name}</div>
      {info && <div className="info-label">({info})</div>}
    </MenuItem>
  }
}

export default Result
